import "core-js/actual/promise/with-resolvers";

import Batcher from "./Batcher.mts";

class AsyncBatcher<T, R> extends Batcher<T, Promise<R>> {
  private pending = false;

  constructor(protected readonly fn: (buffer: T[]) => Promise<R>) {
    super();
  }

  protected scheduleFlush() {
    if (!this.pending) this.flush();
  }

  flush() {
    if (this.buffer.length === 0) {
      this.pending = false;
      return;
    }

    this.pending = true;

    return this.call().then((res) => {
      this.flush();
      return res;
    });
  }
}

export default AsyncBatcher;
